import React from 'react';
import { ReactComponent as Mark } from './infasotka-mark.svg';

// Логотип «инфасотка» — векторные контуры Unbounded 800 (не зависят от загрузки
// шрифта). Цвет частей задаётся через CSS (.mtb-logo .la / .lb) под тему.
export default function MobileLogo() {
  return <span className="mtb-logo" aria-label="инфасотка"><Mark /></span>;
}
